import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import SelectUser from 'components/Accounts/SelectUser';

const mapStateToProps = (state) => ({
  customers: state.customers,
  products: state.products,
  salesOrders: state.salesOrders,
  expenses: state.expenses,
  user: state.user
});

const Accounts = (props) => (
  <>
    <Helmet>
      <title>Accounts | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <SelectUser
          customers={props.customers}
          products={props.products}
          salesOrders={props.salesOrders}
          expenses={props.expenses}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (Accounts);
